import {
  CountryCodes,
  CurrencyCodes,
  Industry,
  LanguageCodes,
  VoiceLlm,
  VoiceStyle,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";

export const EnglishResourcesDictionary: ResourceDictionary = {
  Common: {
    Admin: "Admin",
    AppName: "Vivelo.AI",
    ComingSoon: "Coming soon",
    ComingSoonNote: "The content will be updated soon.",
    BackToSignIn: "Back to sign in",
    Years: "{{count}} years",
    Years_one: "{{count}} year",
    Years_two: "{{count}} years",
    Years_few: "{{count}} years",
    Years_other: "{{count}} years",
    YearsLabel: "years",
    YearsLabel_one: "year",
    YearsLabel_few: "years",
    YearsLabel_other: "years",
    Month: "month",
    Months: "{{count}} months",
    Months_one: "{{count}} month",
    Months_two: "{{count}} months",
    Months_few: "{{count}} months",
    Months_other: "{{count}} months",
    Continue: "Continue",
    Step: "STEP {{actual}} OF {{count}}",
    TextCopied: "Text has been copied to clipboard.",
    Yes: "Yes",
    No: "No",
    Choose: "Choose",
    Download: "Download",
    Upload: "Upload",
    Downloading: "Downloading",
    UnsupportedFileType: "Unsupported file type",
    Email: "Email",
    Password: "Password",
    ExampleLogin: "e.g. john.doe@email.com",
    PiecesShort: "{{count, number}} pcs",
    PiecesSuffix: "pcs",
    Active: "Active",
    Inactive: "Inactive",
    Assigned: "Assigned",
    Actual: "Current",
    Blocked: "Blocked",
    Canceled: "Canceled",
    Cancel: "Cancel",
    Close: "Close",
    Confirm: "Confirm",
    Open: "Open",
    Ended: "Ended",
    All: "All",
    AllStatuses: "All statuses",
    PrivacyPolicyLink: "Privacy Policy.",
    Error:
      "Something went wrong. We apologize for the inconvenience. Please try again later.",
    Save: "Save",
    Search: "Search",
    Reset: "Reset",
    WithTax: "incl. VAT",
    WithoutTax: "excl. VAT",
    Edit: "Edit",
    Back: "Back",
    BackToProjects: "Back to projects",
    BackToProject: "Back to project",
    BackToDashboard: "Back to Dashboard",
    BackToClients: "Back to clients",
    BackToClient: "Back to client",
    BackToActors: "Back to actors",
    BackToPartners: "Back to partners",
    BackToPartner: "Back to partner",
    StatusActive: "Active",
    StatusInactive: "Inactive",
    Status: "Status",
    BackToModules: "Back to modules",
    BackToModule: "Back to module",
    BackToPriceCategories: "Back to price categories",
    Delete: "Delete",
    PreviousStep: "Previous step",
    SaveAndClose: "Save and close",
    SaveSuccess: "Saved successfully.",
    CompanyNumber: "Company No.",
    TaxNumber: "Tax No.",
    PersonalNumber: "Personal No.",
    ProcessedByRepresentative: "Processed by{{gender}} {{name}}",
    SendByRepresentative: "Sent by{{gender}} {{name}}",
    SignOut: "Sign out",
    Language: "Language",
    Users: "Users",
    NewProject: "New project",
    NewActor: "New actor",
    NewPartner: "New partner",
    NewModule: "New module",
    NewClient: "New client",
    Dashboard: "Dashboard",
    Projects: "Projects",
    Actors: "Actors",
    Partners: "Partners",
    Modules: "Modules",
    PriceCategories: "Price categories",
    NewPriceCategory: "New price category",
    Clients: "Clients",
    MusicAudio: "Music & audio",
    Wallet: "Wallet",
    Invoices: "Invoices",
    WithdrawalApprovals: "Actor Withdrawals",
    RegistrationRequests: "Registration Requests",
    BackToWithdrawalApprovals: "Back to actor withdrawals",
    BackToRegistrationRequests: "Back to registration requests",
    ActivityLog: "Activity Log",
    Reporting: "Reporting",
    GoodMorning: "Good morning, {{name}}",
    StatusDone: "Done",
    StatusClosed: "Closed",
    StatusInProgress: "In progress",
    StatusDraft: "Draft",
    StatusWaitingForApproval: "Waiting for approval",
    StatusRejectedByActor: "Rejected by actor",
    StatusAwaitingFunds: "Awaiting Funds",
    NoItems: "No items",
    Currency: "Currency",
    Currencies: {
      [CurrencyCodes.EUR]: "Euro (€)",
      [CurrencyCodes.USD]: "US dollar ($)",
      [CurrencyCodes.CZK]: "Czech koruna (Kč)",
      [CurrencyCodes.GBP]: "British pound (£)",
      [CurrencyCodes.PLN]: "Polish zloty (zł)",
      [CurrencyCodes.CHF]: "Swiss franc (CHF)",
      [CurrencyCodes.SEK]: "Swedish krona (kr)",
      [CurrencyCodes.NOK]: "Norwegian krone (kr)",
      [CurrencyCodes.DKK]: "Danish krone (kr)",
      [CurrencyCodes.HUF]: "Hungarian forint (Ft)",
      [CurrencyCodes.RON]: "Romanian leu (lei)",
    },
    Languages: {
      [LanguageCodes.Czech]: "Czech",
      [LanguageCodes.English]: "English",
      [LanguageCodes.Deutsch]: "German",
      [LanguageCodes.French]: "French",
      [LanguageCodes.Italian]: "Italian",
      [LanguageCodes.Spanish]: "Spanish",
      [LanguageCodes.Polish]: "Polish",
      [LanguageCodes.Dutch]: "Dutch",
      [LanguageCodes.Romanian]: "Romanian",
      [LanguageCodes.Hungarian]: "Hungarian",
      [LanguageCodes.Portuguese]: "Portuguese",
      [LanguageCodes.Swedish]: "Swedish",
      [LanguageCodes.Bulgarian]: "Bulgarian",
      [LanguageCodes.Danish]: "Danish",
      [LanguageCodes.Finnish]: "Finnish",
      [LanguageCodes.Slovak]: "Slovak",
      [LanguageCodes.Croatian]: "Croatian",
      [LanguageCodes.Lithuanian]: "Lithuanian",
      [LanguageCodes.Slovenian]: "Slovenian",
      [LanguageCodes.Latvian]: "Latvian",
      [LanguageCodes.Estonian]: "Estonian",
      [LanguageCodes.Greek]: "Greek",
      [LanguageCodes.Maltese]: "Maltese",
      [LanguageCodes.Irish]: "Irish",
    },
    Countries: {
      [CountryCodes.AT]: "Austria",
      [CountryCodes.BE]: "Belgium",
      [CountryCodes.BG]: "Bulgaria",
      [CountryCodes.CY]: "Cyprus",
      [CountryCodes.CZ]: "Czech Republic",
      [CountryCodes.DE]: "Germany",
      [CountryCodes.DK]: "Denmark",
      [CountryCodes.EE]: "Estonia",
      [CountryCodes.ES]: "Spain",
      [CountryCodes.FI]: "Finland",
      [CountryCodes.FR]: "France",
      [CountryCodes.GR]: "Greece",
      [CountryCodes.HR]: "Croatia",
      [CountryCodes.HU]: "Hungary",
      [CountryCodes.IE]: "Ireland",
      [CountryCodes.IT]: "Italy",
      [CountryCodes.LT]: "Lithuania",
      [CountryCodes.LU]: "Luxembourg",
      [CountryCodes.LV]: "Latvia",
      [CountryCodes.MT]: "Malta",
      [CountryCodes.NL]: "Netherlands",
      [CountryCodes.PL]: "Poland",
      [CountryCodes.PT]: "Portugal",
      [CountryCodes.RO]: "Romania",
      [CountryCodes.SE]: "Sweden",
      [CountryCodes.SI]: "Slovenia",
      [CountryCodes.SK]: "Slovakia",
    },
    Industries: {
      [Industry.Retail]: "Retail",
      [Industry.Finance]: "Finance",
      [Industry.Automotive]: "Automotive",
      [Industry.Ecommerce]: "E-commerce",
      [Industry.EnergyAndUtilities]: "Energy & Utilities",
      [Industry.Pharmaceuticals]: "Pharmaceuticals",
      [Industry.Gaming]: "Gaming",
      [Industry.LogisticsAndTransport]: "Logistics & Transport",
      [Industry.MediaAndEntertainment]: "Media & Entertainment",
      [Industry.FashionAndLifestyle]: "Fashion & Lifestyle",
      [Industry.RealEstate]: "Real Estate",
      [Industry.NonProfit]: "Non-Profit",
      [Industry.HospitalityAndTourism]: "Hospitality & Tourism",
      [Industry.Insurance]: "Insurance",
      [Industry.FoodAndGastronomy]: "Food & Gastronomy",
      [Industry.LegalServices]: "Legal Services",
      [Industry.AdvertisingAndMarketing]: "Advertising & Marketing",
      [Industry.SportsAndFitness]: "Sports & Fitness",
      [Industry.TechnologyAndIT]: "Technology & IT",
      [Industry.Telecommunications]: "Telecommunications",
      [Industry.PublicSector]: "Public Sector",
      [Industry.Education]: "Education",
      [Industry.Healthcare]: "Healthcare",
      [Industry.Other]: "Other",
    },
    VoiceLlms: {
      [VoiceLlm.ElevenLabs_V3]: "ElevenLabs V3",
      [VoiceLlm.ElevenLabs_V2]: "ElevenLabs V2",
      [VoiceLlm.MicrosoftTts]: "Microsoft TTS",
      [VoiceLlm.AiVoice]: "AIVoice",
    },
    VoiceStyles: {
      [VoiceStyle.Neutral]: "Neutral",
      [VoiceStyle.Cheerful]: "Cheerful",
      [VoiceStyle.Excited]: "Excited",
      [VoiceStyle.Friendly]: "Friendly",
      [VoiceStyle.Sad]: "Sad",
      [VoiceStyle.Angry]: "Angry",
      [VoiceStyle.Calm]: "Calm",
      [VoiceStyle.Newscast]: "Newscast",
      [VoiceStyle.Whispering]: "Whispering",
      [VoiceStyle.Authoritative]: "Authoritative",
      [VoiceStyle.Empathetic]: "Empathetic",
    },
  },
  JobDetail: {
    SelectLanguageModelPlaceholder: "Select language model",
    InstructionsPlaceholder: "Enter instructions for text generation...",
    PrepareYourVoicelines: "Voice spot script",
    GeneratePreview: "Generate preview",
    GenerateFullVoiceover: "Generate full voiceover",
    VoicelinesMustBeFilledFirst: "Text must be filled in first",
    FailedToGeneratePreview: "Failed to generate preview",
    FailedToGenerateClip: "Failed to generate clip",
    GeneralSettingsTab: "General settings",
    ParametersTab: "Parameters",
    FinalizeTab: "Generated outputs",
    SegmentSettingsTab: "Segment settings",
    BackgroundMusic: "Background music",
    NoMusic: "No music",
    SelectBackgroundMusic: "Select background music",
    SelectFinalClip: "Select final clip",
    AlreadyFinalized: "This job has already been finalized.",
    FinalClipReady: "Final clip is ready.",
    DownloadFinalClip: "Download final clip",
    Clip: "Clip",
    ClipPreview: "Preview",
    FinalizeConfirm: "Finalize",
    FinalizeSuccess: "Job has been finalized successfully",
    FinalizeError: "Failed to finalize job",
    FinalizeInsufficientBalance: "Insufficient credit to pay for this job",
    DefaultVoiceModel: "Default voice model",
    GlobalLanguage: "Global language",
    Language: "Language",
    GlobalSpeed: "Global speed",
    GlobalVolume: "Global volume",
    CostLimit: "Cost limit",
    Variables: "Variables",
    AddVariable: "Add variable",
    // Script editor
    SegmentText: "Text",
    VoiceSegmentHeading: "Voice",
    PauseSegmentHeading: "Pause",
    AddVoiceSegment: "Add voice",
    AddPause: "Add pause",
    AddBackgroundAudio: "Add media",
    DeleteSegment: "Delete segment",
    NoSegmentSelected: "Select a segment in the editor",
    SelectVoiceModel: "Select voice model",
    Emotion: "Emotion",
    EmotionAndReactions: "Emotion and reactions",
    SpeedFactor: "Speed",
    VolumePercent: "Volume",
    PauseDuration: "Pause duration",
    Seconds: "s",
    VariableName: "Variable name",
    VariableDefaultValue: "Default value",
    AddVariableDialogTitle: "Add variable",
    AddVariableDialogConfirm: "Add",
    DeleteVariable: "Delete variable",
    ScriptErrors: "Script contains {{count}} errors, fix them before saving.",
    SegmentEmptyText: "Segment contains no text",
    SegmentNoActor: "Select an actor for this segment",
    SegmentNoFile: "Select a file for this segment",
    SegmentZeroDuration: "Pause duration must be greater than 0",
    SegmentInvalidStartTime: "Start time must be a positive number",
    SegmentInvalidSpeedFactor: "Speed must be between 0.5x and 2.0x",
    EmptyScript: "Script contains no segments",
    SaveScript: "Save",
    SaveScriptSuccess: "Script saved successfully",
    SaveScriptError: "Failed to save script",
    ExpectedPrice: "Expected price",
    ExpectedLength: "Expected length",
    SelectActorFirst: "Select an actor first",
    AddSegmentTooltip: "Add segment",
    RemoveEmotion: "No emotion",
    // AI integration
    AiRefinementTitle: "AI refinement",
    AiTab: "AI",
    AiDraftTitle: "AI text draft",
    AiDraftDescription:
      "Enter instructions and AI will generate a voiceover text draft. You can refine the text and then convert it to a script.",
    ConvertToScript: "Convert to script",
    ConvertToVoiceSegments: "Convert to voice segments",
    CopyToClipboard: "Copy to clipboard",
    SkipToManualEdit: "Skip, write manually",
    BackToQuestionnaire: "Back to questions",
    RegenerateFromQuestionnaire: "Regenerate",
    BackToAiDraft: "Back to AI draft and questions",
    WorkingArtifact: "Working artifact",
    AiDraftEmptyState:
      "Enter instructions and AI will help you compose the first draft.",
    AiArtifactEmptyState:
      "Enter instructions for script refinement. AI suggestions will appear here and you can add them to the script with one click.",
    AddToScript: "Add to script",
    JobNotFound: "Job not found",
    AudioFormat: "Audio format",
    SampleRate: "Sample rate",
    Bitrate: "Bitrate",
    AudioChannels: "Channels",
    ScriptEditorEmptyState: "Add the first segment using the buttons above",
    DeletePause: "Delete pause",
    DeleteMedia: "Delete media",
    JobReadOnlyBanner: "This job is locked and cannot be edited.",
    AddVariableTooltip: "Insert variable at cursor position / wrap selection",
    DefaultVariableName: "new_variable",
    MediaStartAt: "Playback start",
    MediaDuration: "Playback duration",
    ClipPrice: "Clip price",
    AwaitingFundsMessage:
      "All actors have approved, but the account balance is insufficient for finalization. Top up your credit and try again.",
    RetryFinalization: "Retry finalization",
    RetryFinalizationSuccess: "Job has been finalized successfully",
    RetryFinalizationError: "Failed to finalize job",
    Activate: "Activate",
    Deactivate: "Deactivate",
    ActivateSuccess: "Job activated successfully",
    DeactivateSuccess: "Job deactivated successfully",
    StatusChangeError: "Failed to change job status",
    AddReaction: "Add reaction",
    AddReactionTooltip:
      "Insert a reaction (laugh, whisper, …) at the cursor position. Only available for ElevenLabs v3.",
    ReactionOnlyV3Hint:
      "Reactions are supported only by ElevenLabs v3 voices; other models will ignore them.",
    Reaction: {
      Heading: "Reaction",
      CategoryReactions: "Reactions",
      CategoryVolumeEnergy: "Volume & energy",
      CategoryPacing: "Pacing & rhythm",
      Custom: "Custom",
      CustomPlaceholder: "e.g. angry english accent",
      RemoveReaction: "Remove reaction",
      EditReaction: "Edit reaction",
      Values: {
        Gasp: "Gasp",
        Sigh: "Sigh",
        Laughs: "Laughs",
        Gulps: "Gulps",
        Crying: "Crying",
        EvilLaugh: "Evil laugh",
        Hums: "Hums",
        Giggle: "Giggle",
        Whispering: "Whispering",
        Shouting: "Shouting",
        Quietly: "Quietly",
        Loudly: "Loudly",
        Sings: "Sings",
        Sarcastic: "Sarcastic",
        Stammers: "Stammers",
        Rushed: "Rushed",
      },
    },
    Wizard: {
      StepQuestionnaire: "Questions",
      StepAiDraft: "AI Draft",
      StepScriptEditor: "Script Editor",
    },
    ChoiceScreen: {
      Title: "How do you want to start?",
      Description: "Choose how you want to create the voiceover draft.",
      AnswerQuestionsTitle: "Answer questions",
      AnswerQuestionsDescription:
        "Answer prepared questions and the text will be generated automatically based on your answers.",
      OwnPromptTitle: "Write own instructions",
      OwnPromptDescription:
        "Skip questions and provide your own instructions for the AI directly.",
    },
    Questionnaire: {
      Title: "Answer questions",
      Description:
        "Answer the following questions. A text draft will be generated based on your answers.",
      Generate: "Generate draft",
      Continue: "Continue",
      Skip: "Skip",
      EditAnswers: "Edit Answers",
      OtherOption: "Other",
      AnswersSaved: "Answers saved.",
      Back: "Back",
      GeneratingDraft: "Generating text draft...",
    },
  },
  Dashboard: {
    CreateNewProject: "Create new project",
    RecentProjects: "Recent projects",
    SingleActorVoiceMax60s: "Single actor - max. 60 seconds",
    ProjectName: "Project name",
    Client: "Client",
    License: "License",
    Jobs: "Jobs",
    Budget: "Budget",
    Expense: "Expenses",
    Status: "Status",
    SearchProjects: "Search projects",
    SearchProjectsPlaceholder: "Project name, client...",
    AllClients: "All clients",
    AllStatuses: "All statuses",
    Active: "Active",
    Completed: "Completed",
    Pending: "Pending",
    ReportingOverview: "Reporting overview",
    ViewFullReport: "View full report",
    PendingWithdrawals: "Pending withdrawal requests",
    NoPendingWithdrawals: "No pending withdrawal requests.",
    ViewAllWithdrawals: "View all withdrawals",
  },
  ActivityLog: {
    Title: "Activity Log",
    Timestamp: "Time",
    User: "User",
    Event: "Event",
    Note: "Note",
    Detail: "Detail",
    AllEventTypes: "All events",
    DateFrom: "Date from",
    DateTo: "Date to",
    NoActivities: "No activities to display",
    ActorCreated: "Actor created",
    ActorPriceCategoryChanged: "Actor price category changed",
    PartnerCreated: "Partner created",
    ProjectCreated: "Project created",
    ProjectCompleted: "Project completed",
    ProjectClosed: "Project closed",
    JobCompleted: "Job completed",
    PartnerCreditTopUp: "Partner credit top-up",
    ActorPayoutApproved: "Actor payout approved",
    ClientCreated: "Client created",
  },
  Projects: {
    DefaultLanguageOption: "Default (actor's language)",
    CreateProjectModal: {
      Title: "Create new project",
      SelectModule: "Select module",
      SelectModulePlaceholder: "Select module",
      Client: "Client",
      SelectClientPlaceholder: "Select client",
      Name: "Name",
      NamePlaceholder: "Enter project name",
      Industry: "Industry",
      SelectIndustryPlaceholder: "Select industry",
      Language: "Language",
      SelectLanguagePlaceholder: "Select language",
      LicensedCountries: "Licensed countries",
      SelectLicensedCountriesPlaceholder: "Select licensed countries",
      JobsLimit: "Jobs limit",
      JobsLimitPlaceholder: "Enter maximum number of jobs",
      AmountLimit: "Amount limit",
      AmountLimitPlaceholder: "Enter maximum amount",
      StartDate: "Start date",
      EndDate: "End date",
      ProjectState: "Project status",
      ProjectStatePlaceholder: "Select project status",
      Create: "Create",
      SuccessMessage: "Project created successfully",
      ErrorMessage: "Failed to create project",
      HasExclusiveContracts: "I have an exclusive contract with actor(s)",
      ContractedActor: "Contracted actor",
      ContractPrice: "Contract price",
      ContractJobsLimit: "Contract jobs limit",
      AddExclusiveContract: "Add another exclusive contract",
    },
    EditProjectModal: {
      Title: "Edit project",
      Edit: "Save",
      SuccessMessage: "Project updated successfully",
      ErrorMessage: "Failed to update project",
    },
    CreateJobModal: {
      Title: "Create new job",
      Name: "Name",
      NamePlaceholder: "Enter job name",
      Create: "Create",
      SuccessMessage: "Job created successfully",
      ErrorMessage: "Failed to create job",
    },
    ProjectActorsModal: {
      Title: "Add actors to project",
      Approve: "Approve",
      SuccessMessage: "Actor list updated successfully",
      ErrorMessage: "Failed to update actor list",
      CannotRemoveActorWithActiveJobs:
        "Cannot remove actor with completed or pending jobs.",
    },
    ProjectDetail: {
      Information: "Information",
      EditInformation: "Edit information",
      Industry: "Industry",
      Client: "Client",
      Language: "Language",
      LicenceForStates: "Licensed countries",
      JobsLimit: "Jobs limit",
      CurrentJobs: "Current jobs",
      StartDate: "Start date",
      EndDate: "End date",
      Jobs: "Jobs",
      AddJobToProject: "New Job",
      JobsLimitExceeded: "Jobs limit has been reached",
      JobLocked: "Job is locked",
      Actors: "Actors",
      Actor: "Actor",
      AddActorToProject: "Add actor to project",
      CloseProject: "Close project",
      FinishProject: "Finish project",
      CloseProjectConfirmTitle: "Close project",
      CloseProjectConfirmContent:
        "Are you sure you want to close this project? This action cannot be undone.",
      FinishProjectConfirmTitle: "Finish project",
      FinishProjectConfirmContent:
        "Are you sure you want to mark this project as finished? This action cannot be undone.",
      DocumentsAndInvoices: "Documents & invoices",
      NoDocumentsYet: "No documents yet",
      ProjectNotFound: "Project not found",
      ProjectAmendment: "Project amendment",
      CannotChangeActorBlocked: "Cannot change actor — completed jobs exist",
      ExclusiveContract: "Exclusive contract",
    },
  },
  Actors: {
    Name: "Name",
    ActorName: "Actor name",
    NativeLanguage: "Native language",
    Age: "Age",
    Sex: "Gender",
    PricePerModule: "Price/Module",
    AllLanguages: "All languages",
    AllAges: "All ages",
    AllSexes: "All genders",
    AllPrices: "All prices",
    Male: "Male",
    Female: "Female",
    CreateActorModal: {
      Title: "New actor",
      FirstName: "First name",
      FirstNamePlaceholder: "Enter first name",
      LastName: "Last name",
      LastNamePlaceholder: "Enter last name",
      Email: "Email",
      EmailPlaceholder: "Enter email",
      Phone: "Phone",
      PhonePlaceholder: "Enter phone number",
      DateOfBirth: "Date of birth",
      Gender: "Gender",
      GenderPlaceholder: "Select gender",
      Language: "Native language",
      LanguagePlaceholder: "Select language",
      Industry: "Industry",
      IndustryPlaceholder: "Select industry",
      Address: "Address",
      AddressPlaceholder: "Enter address",
      City: "City",
      CityPlaceholder: "Enter city",
      PostalCode: "Postal code",
      PostalCodePlaceholder: "Enter postal code",
      Country: "Country",
      CountryPlaceholder: "Select country",
      IBAN: "IBAN",
      IBANPlaceholder: "Enter IBAN",
      SWIFT: "SWIFT/BIC",
      SWIFTPlaceholder: "Enter SWIFT/BIC",
      Invoicing: "Invoicing details (self-employed, company, agency)",
      BusinessName: "Business name",
      BusinessNamePlaceholder: "Enter business name",
      CompanyNumber: "Company No.",
      CompanyNumberPlaceholder: "Enter company number",
      TaxNumber: "Tax No.",
      TaxNumberPlaceholder: "Enter tax number",
      BillingAddress: "Address",
      BillingAddressPlaceholder: "Enter billing address",
      BillingCity: "City",
      BillingCityPlaceholder: "Enter city",
      BillingPostalCode: "Postal code",
      BillingPostalCodePlaceholder: "Enter postal code",
      BillingCountry: "Country",
      BillingCountryPlaceholder: "Select country",
      BillingIBAN: "IBAN",
      BillingIBANPlaceholder: "Enter IBAN",
      BillingSWIFT: "SWIFT/BIC",
      BillingSWIFTPlaceholder: "Enter SWIFT/BIC",
      Create: "Create",
      SuccessMessage: "Actor created successfully",
      ErrorMessage: "Failed to create actor",
    },
    EditActorModal: {
      Title: "Edit actor",
      Save: "Save",
      SuccessMessage: "Actor updated successfully",
      ErrorMessage: "Failed to update actor",
    },
    ProfilePicture: {
      UploadPhoto: "Upload profile picture",
      ChangePhoto: "Change profile picture",
      DeletePhoto: "Delete photo",
      CropTitle: "Edit profile picture",
      Zoom: "Zoom",
      UploadError: "Failed to upload profile picture",
      DeleteError: "Failed to delete profile picture",
    },
    ActorDetail: {
      Information: "Information",
      EditInformation: "Edit information",
      Email: "Email",
      Phone: "Phone",
      DateOfBirth: "Date of birth",
      Gender: "Gender",
      NativeLanguage: "Native language",
      Industry: "Industry",
      Address: "Address",
      City: "City",
      PostalCode: "Postal code",
      State: "Country",
      IBAN: "IBAN",
      SWIFT: "SWIFT/BIC",
      BusinessName: "Business name",
      CompanyNumber: "Company No.",
      TaxNumber: "Tax No.",
      BusinessAddress: "Billing address",
      BillingIBAN: "IBAN (billing)",
      BillingSWIFT: "SWIFT/BIC (billing)",
      BackToActors: "Back to actors",
      NotFound: "Actor not found",
      Activate: "Activate",
      Deactivate: "Deactivate",
      ActivateSuccess: "Actor activated successfully",
      DeactivateSuccess: "Actor deactivated successfully",
      StatusChangeError: "Failed to change actor status",
      VoiceActivateSuccess: "Voice activated successfully",
      VoiceDeactivateSuccess: "Voice deactivated successfully",
      Voices: "Voices",
      Videos: "Videos",
      Transactions: "Transactions",
      TrainedVoices: "Trained voices",
      NewVoice: "New voice",
      VoiceModuleRates: "Voice module rates",
      UpdateRates: "Edit rates",
      NoRatesConfigured: "No rates configured",
      ContractsAndAmendments: "Contracts & amendments",
      NewAmendment: "New amendment",
      ProjectAmendments: "Project amendments",
      PriceCategories: {
        PricingModel: "Pricing model",
        ActorsCut: "Actor's cut",
        DefaultPriceTooltip: "Default price",
        Commission: "Commission",
        FinalPrice: "Final price",
        Notes: "Notes",
        State: "Status",
        Approval: "Approval",
        NotSet: "-",
        SaveAmendment: {
          SuccessMessage: "Rates saved successfully",
          ErrorMessage: "Failed to save rates",
        },
      },
      NoTrainedVoices: "No trained voices yet",
      Trained: "Trained",
      VoiceName: "Voice name",
      Tags: "Tags",
      VoiceTraining: "Voice training",
      TrainingModel: "Training model",
      TrainingType: "Training type",
      ExternalVoiceID: "External voice ID",
      ModelID: "Model ID",
      UploadTrainingData: "Upload training data",
      Files: "files",
      RemoveAllFiles: "Remove all files",
      SearchExternalVoice: "Search external voice",
      ContinueToEditAndPreview: "Continue to edit and preview",
      UploadFilesRequired:
        "At least one training file must be uploaded to continue",
      DemoPreview: "Demo preview",
      Speed: "Speed",
      Volume: "Volume",
      GeneratePreview: "Generate preview",
      StartTraining: "Start training",
      VoiceStatus: {
        Draft: "Draft",
        UploadingTrainingFiles: "Uploading files",
        TrainingInProcess: "Training in progress",
        TrainingCompleted: "Training completed",
        TrainingFailed: "Training failed",
        TrainingVerificationRequired: "Verification required",
        Active: "Active",
        Inactive: "Inactive",
      },
      VoiceTrainingTypes: {
        ElevenLabs_Instant: "ElevenLabs Instant",
        ElevenLabs_Professional: "ElevenLabs Professional",
      },
      NewVoiceModal: {
        Title: "New voice",
        Create: "Create",
        SuccessMessage: "Voice created successfully",
        ErrorMessage: "Failed to create voice",
      },
      EditVoiceModal: {
        Title: "Edit voice",
        Save: "Save",
        SuccessMessage: "Voice updated successfully",
        ErrorMessage: "Failed to update voice",
      },
      GeneratePreviewError: {
        General: "Failed to generate preview",
        WrongStatus: "Voice must be trained first",
      },
      OpenToCollaboration: "Open to collaboration",
      NotOpenToCollaboration: "Not open to collaboration",
    },
    ActorPriceCategoryStatus: {
      Allowed: "Allowed",
      NotAllowed: "Not allowed",
      Exclusive: "Exclusive",
    },
    ActorPriceCategoryApprovalType: {
      Automatic: "Automatic",
      Manual: "Manual",
    },
  },
  Partners: {
    PartnerName: "Partner name",
    Projects: "Projects",
    Email: "Email",
    Phone: "Phone",
    SearchPartnersPlaceholder: "Partner name",
    AddSubPartnerButton: "Add sub-partner",
    CreatePartnerModal: {
      Title: "Create new partner",
      BusinessName: "Business name",
      BusinessNamePlaceholder: "Enter business name",
      SuperiorPartner: "Superior partner",
      SuperiorPartnerPlaceholder: "Select superior partner",
      IdentificationNumber: "Company No.",
      IdentificationNumberPlaceholder: "Enter company number",
      VAT: "Tax No.",
      VATPlaceholder: "Enter tax number",
      Email: "Email",
      EmailPlaceholder: "Enter email",
      Phone: "Phone",
      PhonePlaceholder: "Enter phone number",
      Address: "Address",
      AddressPlaceholder: "Enter address",
      City: "City",
      CityPlaceholder: "Enter city",
      PostalCode: "Postal code",
      PostalCodePlaceholder: "Enter postal code (e.g. 12345)",
      Country: "Country",
      CountryPlaceholder: "Select country",
      Create: "Create",
      AllowRetroactivePayment:
        "Allow partner to make retroactive invoice payments",
      SuccessMessage: "Partner created successfully",
      ErrorMessage: "Failed to create partner",
    },
    PartnerDetail: {
      Information: "Information",
      EditInformation: "Edit information",
      CompanyNumber: "Company No.",
      TaxNumber: "Tax No.",
      Email: "Email",
      Phone: "Phone",
      Address: "Address",
      City: "City",
      PostalCode: "Postal code",
      State: "Country",
      Projects: "Projects",
      NoProjects: "No projects",
      Contracts: "Contracts",
      NoContracts: "No contracts",
      ParentPartner: "Parent partner",
      BackToPartners: "Back to partners",
      AvailableModules: "Available modules",
      NoModules: "No modules",
      EditAvailableModules: "Edit available modules",
      Clients: "Clients",
      NoClients: "No clients",
      Activate: "Activate",
      Deactivate: "Deactivate",
      ActivateSuccess: "Partner activated successfully",
      DeactivateSuccess: "Partner deactivated successfully",
      StatusChangeError: "Failed to change partner status",
    },
    EditAvailableModulesModal: {
      Title: "Edit available modules",
      SearchPlaceholder: "Search module",
      ModuleName: "Module name",
      BaseModule: "Base module",
      Save: "Save",
      SuccessMessage: "Available modules updated successfully",
      ErrorMessage: "Failed to update available modules",
    },
    EditPartnerModal: {
      Title: "Edit partner",
      Save: "Save",
      SuccessMessage: "Partner updated successfully",
      ErrorMessage: "Failed to update partner",
    },
  },
  Modules: {
    ModuleBase: "Module type",
    ModuleName: "Module name",
    Projects: "Projects",
    LastUpdated: "Last updated",
    Availability: "Availability",
    SearchModulesPlaceholder: "Module name",
    AvailabilityActive: "Active",
    AvailabilityInactive: "Inactive",
    CreateModuleModal: {
      Title: "Create new module",
      Name: "Name",
      NamePlaceholder: "Enter module name",
      Type: "Module type",
      TypePlaceholder: "Select module type",
      PriceCategory: "Pricing model",
      PriceCategoryPlaceholder: "Select pricing model",
      CustomPrompt: "Custom prompt",
      CustomPromptPlaceholder: "Enter custom prompt for the module",
      TextLlmsSection: "Text model configuration:",
      VoiceLlmsSection: "Voice model configuration:",
      Create: "Create",
      SuccessMessage: "Module created successfully",
      ErrorMessage: "Failed to create module",
    },
    ModuleTypes: {
      SingleVoiceSpot: "Single voice spot",
      MultiVoiceSpot: "Multi voice spot",
    },
    TextLlms: {
      OpenAI_ChatGpt5: "OpenAI ChatGPT 5",
    },
    VoiceLlms: {
      ElevenLabs_V3: "ElevenLabs V3",
      ElevenLabs_V2: "ElevenLabs V2",
      MicrosoftTts: "Microsoft TTS",
    },
    ModuleDetail: {
      BackToModules: "Back to modules",
      Information: "Module information",
      EditInformation: "Edit information",
      ModuleName: "Module name",
      ModuleType: "Module type",
      Status: "Status",
      PriceCategory: "Pricing model",
      TextModels: "Text models",
      VoiceModels: "Voice models",
      CustomPromptSection: "Custom prompt",
      NotFound: "Module not found",
      Activate: "Activate",
      Deactivate: "Deactivate",
      ActivateSuccess: "Module activated successfully",
      DeactivateSuccess: "Module deactivated successfully",
      StatusChangeError: "Failed to change module status",
      AvailablePartners: "Available for",
      NoPartners: "No partners",
      EditAvailablePartners: "Edit partners",
    },
    EditModuleModal: {
      Title: "Edit module",
      Save: "Save",
      SuccessMessage: "Module updated successfully",
      ErrorMessage: "Failed to update module",
    },
    EditAvailablePartnersModal: {
      Title: "Available partners",
      SearchPlaceholder: "Search partners...",
      PartnerName: "Partner",
      Save: "Save",
      SuccessMessage: "Partners saved successfully",
      ErrorMessage: "Failed to save partners",
    },
    Questions: {
      Title: "Module Questions",
      EditQuestions: "Edit Questions",
      NoQuestions: "No questions configured",
      AddQuestion: "Add Question",
      RemoveQuestion: "Remove Question",
      QuestionText: "Question Text",
      QuestionTextPlaceholder: "Enter question text...",
      QuestionType: "Question Type",
      Required: "Required",
      Options: "Options",
      AddOption: "Add Option",
      RemoveOption: "Remove Option",
      OptionTextPlaceholder: "Option text...",
      SaveSuccess: "Module questions saved successfully.",
      OtherOptionLabel: "Other (text answer)",
      ValidationQuestionTextRequired: "Enter question text.",
      ValidationOptionTextRequired: "Enter option text.",
      ValidationOptionsRequired: "Add at least one option.",
      Types: {
        Text: "Text Answer",
        SingleChoice: "Single Choice",
        MultiChoice: "Multiple Choice",
        SingleChoiceWithOther: "Single Choice + Other",
        MultiChoiceWithOther: "Multiple Choice + Other",
      },
    },
  },
  PriceCategories: {
    Name: "Name",
    Type: "Type",
    CommissionRate: "Commission",
    DefaultPrice: "Default price",
    DateCreated: "Date created",
    DateUpdated: "Date updated",
    SearchPlaceholder: "Price category name",
    PriceCategoryTypes: {
      PerMinute: "Per minute",
      PerJob: "Per job",
    },
    PriceSuffix: {
      PerMinute: "€/min",
      PerJob: "€/job",
      PerProject: "€/project",
    },
    CreateModal: {
      Title: "Create new price category",
      Name: "Name",
      NamePlaceholder: "Enter price category name",
      TypePlaceholder: "Select price category type",
      Create: "Create",
      SuccessMessage: "Price category created successfully",
      ErrorMessage: "Failed to create price category",
    },
    Detail: {
      BackToList: "Back to price categories",
      Information: "Information",
      EditInformation: "Edit information",
      NotFound: "Price category not found",
      Activate: "Activate",
      Deactivate: "Deactivate",
      ActivateSuccess: "Price category activated successfully",
      DeactivateSuccess: "Price category deactivated successfully",
      StatusChangeError: "Failed to change price category status",
    },
    EditModal: {
      Title: "Edit price category",
      Save: "Save",
      SuccessMessage: "Price category updated successfully",
      ErrorMessage: "Failed to update price category",
    },
  },
  Clients: {
    CompanyName: "Company name",
    Partner: "Partner",
    AllPartners: "All partners",
    Email: "Email",
    Phone: "Phone",
    ProjectCount: "Project count",
    SearchClientsPlaceholder: "Client name, partner...",
    CreateClientModal: {
      Title: "Create new client",
      CompanyName: "Company name",
      CompanyNamePlaceholder: "Enter company name",
      CompanyNumber: "Company No.",
      CompanyNumberPlaceholder: "Enter company number",
      TaxNumber: "Tax No.",
      TaxNumberPlaceholder: "Enter tax number",
      Email: "Email",
      EmailPlaceholder: "Enter email",
      Phone: "Phone",
      PhonePlaceholder: "Enter phone number",
      Address: "Address",
      AddressPlaceholder: "Enter address",
      City: "City",
      CityPlaceholder: "Enter city",
      PostalCode: "Postal code",
      PostalCodePlaceholder: "Enter postal code (e.g. 12345)",
      Country: "Country",
      CountryPlaceholder: "Select country",
      Create: "Create",
      SuccessMessage: "Client created successfully",
      ErrorMessage: "Failed to create client",
    },
    ClientDetail: {
      Information: "Information",
      EditInformation: "Edit information",
      CompanyName: "Company name",
      CompanyNumber: "Company No.",
      TaxNumber: "Tax No.",
      Email: "Email",
      Phone: "Phone",
      Address: "Address",
      City: "City",
      PostalCode: "Postal code",
      State: "Country",
      Projects: "Projects",
      NoProjects: "No projects",
      Contracts: "Contracts",
      NoContracts: "No contracts",
      BackToClients: "Back to clients",
      NotFound: "Client not found",
      Activate: "Activate",
      Deactivate: "Deactivate",
      ActivateSuccess: "Client activated successfully",
      DeactivateSuccess: "Client deactivated successfully",
      StatusChangeError: "Failed to change client status",
    },
    EditClientModal: {
      Title: "Edit client",
      Save: "Save",
      SuccessMessage: "Client updated successfully",
      ErrorMessage: "Failed to update client",
    },
  },
  Users: {
    Login: "Login",
    Name: "Name",
    FirstName: "First name",
    LastName: "Last name",
    SearchUsersPlaceholder: "Search users...",
  },
  MusicAudio: {
    DisplayName: "Name",
    FileName: "File",
    Duration: "Duration",
    DateCreated: "Date created",
    SearchPlaceholder: "Search audio files...",
    UploadModal: {
      Title: "Upload audio file",
      DisplayName: "Name",
      DisplayNamePlaceholder: "File name",
      SelectFile: "Select file",
      Upload: "Upload",
      SuccessMessage: "File uploaded successfully",
      ErrorMessage: "Failed to upload file",
      LicenseConfirmation:
        "By uploading, I confirm that I hold the necessary rights or license to use this audio file.",
    },
    DeleteDialog: {
      Title: "Delete audio file",
      Content: "Are you sure you want to delete this audio file?",
      Confirm: "Delete",
      SuccessMessage: "File deleted successfully",
      ErrorMessage: "Failed to delete file",
    },
    Download: "Download",
    DownloadError: "Failed to download file",
  },
  Billing: {
    CurrentBalance: "Current balance",
    TransactionHistory: "Transaction history",
    Date: "Date",
    Type: "Type",
    Description: "Description",
    Amount: "Amount",
    BalanceAfter: "Balance after",
    TransactionTypes: {
      Deposit: "Deposit",
      JobPayment: "Job payment",
      Withdrawal: "Withdrawal",
      Reversal: "Reversal",
      Adjustment: "Adjustment",
    },
    DepositModal: {
      Title: "Add credit",
      Amount: "Amount (EUR)",
      AmountPlaceholder: "Enter amount",
      Description: "Description",
      DescriptionPlaceholder: "Optional deposit description",
      Confirm: "Proceed to payment",
      SuccessMessage: "Redirecting to payment gateway...",
      ErrorMessage: "Failed to initiate payment",
    },
    InitiateDeposit: "Add credit",
    AvailableFunds: "Available funds",
    Descriptions: {
      withdrawal: "Withdrawal request #{{withdrawalRequestID}}",
      jobPayment: "Payment for job {{jobName}}, project {{projectName}}",
      reversal: "Reversed transaction: {{reason}}",
      reversalPayoutFailed: "Payout failed",
    },
  },
  Invoices: {
    Title: "Invoices",
    InvoiceNumber: "Invoice No.",
    IssueDate: "Issue Date",
    Type: "Type",
    Seller: "Seller",
    Buyer: "Buyer",
    TotalAmount: "Total",
    Status: "Status",
    DownloadInvoice: "Download invoice",
    DownloadError: "Failed to download invoice",
    SearchPlaceholder: "Search invoices...",
    Types: {
      Standard: "Invoice",
      SelfBilling: "Self-billing",
      CreditNote: "Credit note",
    },
    Statuses: {
      Issued: "Issued",
      Paid: "Paid",
      Cancelled: "Cancelled",
    },
  },
  WithdrawalApprovals: {
    ActorName: "Actor",
    Amount: "Amount",
    Status: "Status",
    RequestedAt: "Requested at",
    IBAN: "IBAN",
    SWIFT: "SWIFT",
    ResolvedAt: "Resolved at",
    ResolvedBy: "Resolved by",
    ExpiresAt: "Expires at",
    ActorBalance: "Actor balance",
    EpcQrCode: "EPC QR code for payment",
    CzechQrCode: "QR Payment (CZ)",
    SearchPlaceholder: "Search by actor name...",
    StatusPending: "Pending",
    StatusApproved: "Approved",
    StatusRejected: "Rejected",
    StatusExpired: "Expired",
    Approve: "Approve",
    Reject: "Reject",
    RejectionReason: "Rejection reason",
    RejectionReasonPlaceholder: "Enter rejection reason...",
    ConfirmReject: "Confirm rejection",
    ApproveSuccess: "Withdrawal approved successfully",
    RejectSuccess: "Withdrawal rejected",
    NotFound: "Withdrawal request not found",
  },
  Notifications: {
    Title: "Notifications",
    Actions: "Actions",
    MarkAllAsRead: "Mark all as read",
    DismissAll: "Dismiss all",
    Empty: "No notifications",
    SysAdmin_ActorWithdrawalRequested:
      "Actor {{actorName}} has requested a withdrawal of {{amount}} EUR.",
    SysAdmin_PartnerRegistrationRequested:
      "New partner registration request from {{contactName}} ({{companyName}}).",
    SysAdmin_ActorRegistrationRequested:
      "New actor registration request from {{actorName}} ({{email}}).",
    Partner_JobApprovedByActor:
      "Actor {{actorName}} has approved job {{jobName}} in project {{projectName}}.",
    Partner_JobRejectedByActor:
      "Actor {{actorName}} has rejected job {{jobName}} in project {{projectName}}.",
    RelativeTime: {
      JustNow: "Just now",
      MinutesAgo: "{{count}}m ago",
      HoursAgo: "{{count}}h ago",
      DaysAgo: "{{count}}d ago",
    },
  },
  RegistrationRequests: {
    Name: "Name",
    Type: "Type",
    Status: "Status",
    Email: "Email",
    Phone: "Phone",
    Company: "Company",
    DateCreated: "Date Created",
    SearchPlaceholder: "Search requests...",
    StatusPending: "Pending",
    StatusResolved: "Resolved",
    StatusApproved: "Approved",
    StatusRejected: "Rejected",
    TypePartner: "Partner",
    TypeActor: "Actor",
    AllStatuses: "All statuses",
    AllTypes: "All types",
    Resolve: "Resolve",
    ResolveSuccess: "Request has been resolved successfully.",
    NotFound: "Registration request not found.",
    CreatePartner: "Create partner",
    DetailTitle: "Registration Request Detail",
    FirstName: "First Name",
    LastName: "Last Name",
  },
  Reporting: {
    Title: "Reporting",
    RevenueThisMonth: "Revenue This Month",
    ActiveProjects: "Active Projects",
    NewPartnersThisMonth: "New Partners This Month",
    JobsThisMonth: "Jobs This Month",
    RevenueOverTime: "Revenue Over Time",
    ProjectStatusDistribution: "Project Status Distribution",
    AverageCompletionTime: "Average Completion Time",
    AverageJobCost: "Average Job Cost",
    AverageActorApprovalTime: "Avg. Actor Approval Time",
    Days: "days",
    TopActorsByJobs: "Top Actors by Jobs",
    TopActorsByEarnings: "Top Earning Actors",
    TopPartnersByProjects: "Partners with Most Projects",
    TopPartnersByJobs: "Partners with Most Jobs",
    TopPartnersBySpend: "Top Spending Partners",
    AvgGenerationsPerJob: "Avg Generations per Job",
    VoiceModelUsageThisMonth: "Most Used AI Models This Month",
    JobStatusDistribution: "Job Status Distribution",
    NoData: "No data available",
    Revenue: "Revenue",
    Jobs: "Jobs",
    Earnings: "Earnings",
    PeriodAll: "All time",
    PeriodThisMonth: "This month",
    PeriodLast30Days: "Last 30 days",
    PeriodThisYear: "This year",
    PeriodLastYear: "Last year",
  },
  Errors: {
    ApplicationError: {
      Title: "An error occurred",
      Subtitle: "We're sorry, an error occurred in the application.",
      Description:
        "Our developers have been notified and are already working on a fix.",
      DebugHint: "Are you a developer? Check what went wrong.",
      Home: "Home",
    },
    Error404: {
      Subtitle: "Page not found",
      Home: "Home",
    },
    Error403: {
      Subtitle: "You do not have permission to view this page",
    },
    Error500: "An error occurred while processing the request.",
    UserNotFound: "User not found",
    PartnerNotFound: "Partner not found",
  },
  SignIn: {
    Error: {
      General: "An error occurred",
      AccountIsDisabled: "Account is disabled",
      InvalidCredentials: "Invalid credentials",
      AccountWaitingForEmailConfirmation:
        "Account is waiting for email confirmation",
      ApplicationVerification: "Invalid credentials",
      InvalidToken: "Invalid token",
      PhoneNumberNotFound: "Phone number not found",
      SmsSendingFailed: "Failed to send SMS",
      InsufficientRole: "User with this role is not authorized",
      AccountWaitingForSetPassword: "Account is waiting for password setup",
    },
    Title: "Sign in",
    Subtitle: "Welcome back! Enter your credentials to continue your work.",
    Username: {
      Label: "Username",
    },
    Password: {
      Label: "Password",
    },
    DoNotHaveAccount: "Don't have an account?",
    ForgottenPassword: "Forgot password?",
    RegisterNow: "Register now",
    Cookies: "Cookies",
    Help: "Help",
    Button: "Sign in",
  },
  SignUp: {
    Title: "Partner registration",
    Subtitle:
      "Fill out the registration form and we will contact you shortly with system access.",
    FirstName: { Label: "First name" },
    LastName: { Label: "Last name" },
    Company: { Label: "Company" },
    Email: { Label: "Email" },
    Phone: { Label: "Phone" },
    TermsAndConditions: "By creating an account you agree to AI Connect",
    TermsLink: "terms and conditions",
    Button: "Register",
    AlreadyHaveAccount: "Already have an account?",
    SignInNow: "Sign in",
    RegistrationNote:
      "Actor registration is done through recording sessions. For more information, contact our",
    ProductionTeam: "production team",
    Success: {
      Title: "Request submitted",
      Description:
        "Your registration request has been submitted successfully. We will contact you at the provided email.",
    },
    Error: {
      General: "An error occurred",
      UserExists: "An account with this email already exists",
      DuplicateRequest:
        "A registration request with this email has already been submitted",
      WeakPassword:
        "Password must be at least 8 characters long and contain one lowercase letter, one uppercase letter, and one number",
    },
  },
  RegisterActor: {
    Title: "Actor registration",
    Subtitle:
      "Fill out the registration form and we will contact you shortly with system access.",
    FirstName: { Label: "First name" },
    LastName: { Label: "Last name" },
    Company: { Label: "Company (optional)" },
    Email: { Label: "Email" },
    Phone: { Label: "Phone" },
    TermsAndConditions: "By creating an account you agree to AI Connect",
    TermsLink: "terms and conditions",
    Button: "Register",
    AlreadyHaveAccount: "Already have an account?",
    SignInNow: "Sign in",
    Success: {
      Title: "Request submitted",
      Description:
        "Your registration request has been submitted successfully. We will contact you at the provided email.",
    },
    Error: {
      General: "An error occurred",
      UserExists: "An account with this email already exists",
      DuplicateRequest:
        "A registration request with this email has already been submitted",
    },
  },
  Legal: {
    Body: "This document is being prepared and will be added soon. Thank you for your patience. If you have any questions about how we process personal data or about the terms of use, please contact us.",
    PrivacyPolicy: {
      Title: "Privacy Policy",
    },
    TermsOfService: {
      Title: "Terms of Service",
    },
  },
  Support: {
    Title: "Support & Help",
    Body: "The support page is being prepared and will be added soon. If you need help, please contact us by email and we'll be happy to assist you.",
  },
  Validation: {
    Required: "This field is required",
    InvalidEmail: "Invalid email address",
    AlphabetsOnly: "Only letters are allowed for this field",
    DigitsOnly: "May contain only digits",
    InvalidPhone: "Invalid phone number",
    InvalidFormat: "Invalid format",
    InvalidBankAccount: "Invalid bank account number",
    InvalidPersonalIdentificationNumber:
      "Invalid personal identification number",
    InvalidTaxNumber: "Invalid tax number",
    InvalidCompanyNumber: "Invalid company number",
    InvalidPostalCode: "Invalid postal code format",
    IsTrue: "Must be checked",
    Number: {
      Integer: "Must be a whole number",
      Min: "Value must be non-negative",
      MoreThen: "Must be greater than 0",
    },
    String: {
      Min: "Must be at least {{count}} characters long.",
      Max: "Must be no longer than {{count}} characters.",
      StrictLength: "Must contain exactly {{count}} characters",
      InvalidFormat: "Invalid format",
    },
    Array: {
      Min: "Select at least one item.",
      Min_one: "At least {{count}} item must be selected.",
      Min_few: "At least {{count}} items must be selected.",
      Min_other: "At least {{count}} items must be selected.",
    },
    Date: {
      MustBeAfterStartDate: "End date must be after the start date",
    },
  },
  SetPassword: {
    Title: "Set password",
    Subtitle:
      "To activate your account or change your password, set a new, secure password.",
    Password: { Label: "Password" },
    ConfirmPassword: { Label: "Confirm password" },
    Button: "Set password",
    PasswordsMustMatch: "Passwords must match",
    SuccessMessage: "Password has been set successfully. You can now sign in.",
    Error: {
      General:
        "The password reset link is invalid or has expired. Please request a new link.",
      TokenNotFound: "Invalid link",
      WeakPassword:
        "Password must be at least 8 characters long and contain one lowercase letter, one uppercase letter, and one number",
    },
  },
  ResetPassword: {
    Title: "Reset password",
    Subtitle: "Enter your email and we will send you a password reset link.",
    Email: { Label: "Email" },
    Button: "Send link",
    BackToSignIn: "Back to sign in",
    Success: {
      Title: "Check your email",
      Description:
        "If the email exists in our system, a password reset link has been sent to it.",
    },
  },
  BlDatePicker: {
    Locales: {
      One: "day",
      Two: "days",
      Few: "days",
      Other: "days",
      Many: "days",
      Zero: "days",
    },
    Placeholder: "Select date",
    Presets: {
      Today: "Today",
      Yesterday: "Yesterday",
      Last7Days: "Last 7 days",
      Last30Days: "Last 30 days",
      ThisMonth: "This month",
      LastMonth: "Last month",
    },
  },
  Autocomplete: {
    ClearText: "Clear",
    CloseText: "Close",
    OpenText: "Open",
    NoOptionsText: "No options",
    LoadingText: "Loading...",
  },
  TextEditor: {
    Bold: "Bold",
    Italic: "Italic",
    Underline: "Underline",
    Strikethrough: "Strikethrough",
    Code: "Code",
    Paragraph: "Paragraph",
    Heading1: "Heading 1",
    Heading2: "Heading 2",
    Heading3: "Heading 3",
    BulletList: "Bullet list",
    OrderedList: "Ordered list",
    Blockquote: "Blockquote",
    CodeBlock: "Code block",
    HorizontalRule: "Horizontal rule",
    Superscript: "Superscript",
    Subscript: "Subscript",
    AlignLeft: "Align left",
    AlignCenter: "Align center",
    AlignRight: "Align right",
    AlignJustify: "Justify",
    Highlight: "Highlight",
  },
  Table: {
    NoData: "No data",
    NextPage: "Next page",
    PrevPage: "Previous page",
    RowsPerPage: "Rows per page",
  },
  Documents: {
    SectionTitle: "Documents",
    UploadButton: "Upload document",
    ChooseFile: "Choose file",
    DisplayNameLabel: "Document name",
    UploadModalTitle: "Upload document",
    NoDocuments: "No documents",
    DownloadError: "Failed to download document",
    DeleteError: "Failed to delete document",
    UploadError: "Failed to upload document",
  },
  ApiErrors: {
    General: "An unexpected error occurred. Please try again.",
    SearchExternalVoices: {
      General: "Failed to search voices.",
      UnsupportedVoiceLlm: "The selected voice model is not supported.",
    },
    UploadUserProfilePicture: {
      General: "Failed to upload profile picture.",
      UserNotFound: "User not found.",
      FileTooLarge: "File is too large.",
      InvalidFileType: "Unsupported file format.",
    },
    DeleteUserProfilePicture: {
      General: "Failed to delete profile picture.",
      UserNotFound: "User not found.",
    },
    DocumentUpload: {
      General: "Failed to upload document.",
      EntityNotFound: "Entity not found.",
      FileTooLarge: "File is too large.",
      InvalidFileType: "Unsupported file format.",
    },
    SaveProject: {
      General: "Failed to save project.",
      ClientNotFound: "Client not found.",
      ClientInactive: "Client is deactivated.",
      ModuleNotFound: "Module not found.",
      CurrentUserNotConnectWithPartner:
        "Your account is not connected to any partner.",
      ProjectNotFound: "Project not found.",
      DuplicateExclusiveContractActor:
        "The same actor cannot have multiple exclusive contracts in one project.",
      ExclusiveContractActorNotFound:
        "Actor for the exclusive contract was not found.",
      ExclusiveContractActorIndustryNotAllowed:
        "Actor for the exclusive contract does not have the project's industry enabled.",
    },
    SyncProjectActors: {
      General: "Failed to sync project actors.",
      ProjectNotFound: "Project not found.",
      ActorsNotFound: "Actor(s) not found.",
      ActorPriceCategoryNotAllowed: "Actor's price category is not allowed.",
      ActorNotOpenToCollaboration: "Actor is not open to collaboration.",
      TooManyActorsForSingleVoiceSpot:
        "Too many actors for a single voice spot.",
      CannotChangeActorWithCompletedJobs:
        "Cannot change actors on completed jobs.",
      ActorIndustryNotAllowed: "Actor does not have this industry enabled.",
      CannotRemoveActorWithActiveJobs:
        "Cannot remove actor with completed or pending jobs.",
    },
    SavePriceCategory: {
      General: "Failed to save price category.",
      PriceCategoryNotFound: "Price category not found.",
      NameAlreadyExists: "A price category with this name already exists.",
      CommissionRateOutOfRange: "Commission rate is out of the allowed range.",
    },
    CreatePartnerMediaFile: {
      General: "Failed to upload media file.",
      FileTooLarge: "File is too large.",
      InvalidFileType: "Unsupported file format.",
      PartnerNotFound: "Partner not found.",
      LicenseNotConfirmed:
        "You must confirm that you hold the license to the audio file before uploading.",
    },
    TogglePartnerModule: {
      General: "Failed to change module status.",
      PartnerNotFound: "Partner not found.",
      ModuleNotFound: "Module not found.",
      AlreadyEnabled: "Module is already active.",
      AlreadyDisabled: "Module is already inactive.",
    },
    SetPartnerModules: {
      General: "Failed to save partner modules.",
      PartnerNotFound: "Partner not found.",
      ModuleNotFound: "Module not found.",
    },
    SetModulePartners: {
      General: "Failed to save module partners.",
      ModuleNotFound: "Module not found.",
      PartnerNotFound: "Partner not found.",
    },
    SavePartner: {
      General: "Failed to save partner.",
      ParentPartnerNotFound: "Parent partner not found.",
      HierarchyTooDeep: "Partner hierarchy is too deep.",
      CannotSetParentWithChildren:
        "Cannot set a parent partner when the partner has child partners.",
      CannotBeSelfParent: "A partner cannot be its own parent.",
      UserWithLoginAlreadyExists: "A user with this email already exists.",
    },
    SaveModule: {
      General: "Failed to save module.",
      PriceCategoryNotFound: "Price category not found.",
    },
    SaveModuleQuestions: {
      General: "Failed to save module questions.",
      ModuleNotFound: "Module not found.",
      InvalidQuestionConfiguration: "Invalid question configuration.",
    },
    SaveJobAnswers: {
      General: "Failed to save answers.",
      JobNotFound: "Job not found.",
      MissingRequiredAnswer: "Missing answer to a required question.",
      InvalidOption: "Invalid selected option.",
      InvalidQuestion: "Invalid question.",
      TooManyOptionsForSingleChoice:
        "Only one option can be selected for a single-choice question.",
    },
    CreateJob: {
      General: "Failed to create job.",
      ProjectNotFound: "Project not found.",
      JobsLimitExceeded: "The jobs limit for this project has been exceeded.",
    },
    SaveJobScript: {
      General: "Failed to save script.",
      JobNotFound: "Job not found.",
    },
    GenerateVoicelines: {
      General: "Failed to generate voicelines.",
      ProjectNotFound: "Project not found.",
      JobNotFound: "Job not found.",
      UnsupportedTextLlm: "The selected text model is not supported.",
      GenerationFailed: "Generation failed. Please try again.",
      RateLimited:
        "The text generation service is temporarily overloaded or its request limit has been reached. Please try again shortly.",
    },
    GenerateJobClip: {
      General: "Failed to generate clip.",
      JobNotFound: "Job not found.",
      ScriptNotFound: "Script not found.",
      GenerationFailed: "Generation failed. Please try again.",
      ExclusiveContractJobLimitReached:
        "The exclusive contract job limit for this actor has been reached.",
    },
    RetryFinalization: {
      General: "Failed to retry job finalization.",
      JobNotFound: "Job not found.",
      InvalidJobStatus: "Job is not in the correct status for this action.",
      NotAllApproved: "Not all voicelines have been approved.",
      InsufficientBalance: "Insufficient account balance.",
      FinalizationFailed: "Finalization failed. Please try again.",
    },
    SubmitJob: {
      General: "Failed to submit job.",
      JobNotFound: "Job not found.",
      ClipNotFound: "Clip not found.",
      ClipNotFullType: "Clip is not of full type.",
      JobNotSubmittable: "Job is not in a submittable status.",
      InsufficientBalance: "Insufficient account balance.",
      FinalizationFailed: "Finalization failed. Please try again.",
    },
    GetFileDownloadUrl: {
      General: "Failed to download file.",
      FileNotFound: "File not found.",
    },
    SaveClient: {
      General: "Failed to save client.",
      CompanyNumberAlreadyExists:
        "A client with this company number already exists.",
      UnauthorizedAccess: "You are not authorized to perform this action.",
      PartnerRequired: "A partner is required for this action.",
    },
    InitiateDeposit: {
      General: "Failed to initiate payment.",
      PartnerRequired: "A partner is required for deposits.",
      IdempotencyKeyRequired: "Transaction identifier is missing.",
      InvalidAmount: "The entered amount is invalid.",
    },
    RegisterPartner: {
      General: "Registration failed.",
      UserExists: "An account with this email already exists.",
      DuplicateRequest:
        "A registration request with this email has already been submitted.",
    },
    RegisterActor: {
      General: "Actor registration failed.",
      UserExists: "An account with this email already exists.",
      DuplicateRequest:
        "A registration request with this email has already been submitted.",
    },
    DetectAudioWatermark: {
      General: "Failed to detect watermark.",
      InvalidFileType: "Unsupported file format.",
      UnsupportedAudioFormat: "Unsupported audio format.",
    },
    SaveActorPriceCategories: {
      General: "Failed to save actor price categories.",
      PriceCategoryNotFound: "Price category not found.",
    },
    SaveActor: {
      General: "Failed to save actor.",
      EmailAlreadyExists: "An actor with this email already exists.",
      ActorAlreadyExists: "Actor already exists.",
      PartnerRequired: "A partner is required for this action.",
    },
    SaveActorVoice: {
      General: "Failed to save actor voice.",
      ActorNotFound: "Actor not found.",
      ExternalVoiceIDEmpty: "External voice ID must not be empty.",
      ActorVoiceNotFound: "Actor voice not found.",
      TrainingTypeNotSupportedForVoiceLlm:
        "This training type is not supported by the selected model.",
      CannotChangeVoiceConfigAfterDraft:
        "Voice configuration cannot be changed after leaving draft status.",
    },
    UploadActorVoiceTrainingFile: {
      General: "Failed to upload training file.",
      FileTooLarge: "File is too large.",
      InvalidFileType: "Unsupported file format.",
      ActorVoiceNotFound: "Actor voice not found.",
      MaxFilesExceeded: "Maximum number of training files has been exceeded.",
      ThisVoiceModelCannotBeTrained: "This voice model cannot be trained.",
      DuplicateFile: "This file has already been uploaded.",
      CaptchaFileAlreadyExists: "Captcha file already exists.",
      CaptchaFileNotAllowedForInstant:
        "Captcha file is not allowed for instant training.",
    },
    DeleteActorVoiceTrainingFile: {
      General: "Failed to delete training file.",
      TrainingFileNotFound: "Training file not found.",
      WrongStatus: "Actor voice is not in the correct status for this action.",
    },
    DeleteAllActorVoiceTrainingFiles: {
      General: "Failed to delete training files.",
      ActorVoiceNotFound: "Actor voice not found.",
      WrongStatus: "Actor voice is not in the correct status for this action.",
    },
    GenerateActorVoicePreview: {
      General: "Failed to generate voice preview.",
      ActorVoiceNotFound: "Actor voice not found.",
      WrongStatus: "Actor voice is not in the correct status for this action.",
      InvalidParameters: "Invalid parameters for preview generation.",
      GenerationFailed: "Preview generation failed. Please try again.",
    },
    TrainingActorVoice: {
      General: "Failed to start voice training.",
      LlmModelNotSupportCustomTraining:
        "The selected model does not support custom training.",
      TrainingFilesEmpty: "No training files have been uploaded.",
      ActorVoiceNotFound: "Actor voice not found.",
      WrongStatus: "Actor voice is not in the correct status for this action.",
      CaptchaFileRequired: "A captcha file is required.",
      InsufficientAudioDuration: "Total recording duration is too short.",
    },
    ApproveWithdrawal: {
      General: "Failed to approve withdrawal.",
      NotFound: "Withdrawal request not found.",
      AlreadyProcessed: "This request has already been processed.",
      Expired: "The request has expired.",
      LedgerError: "Error processing payment.",
    },
    RejectWithdrawal: {
      General: "Failed to reject withdrawal.",
      NotFound: "Withdrawal request not found.",
      AlreadyProcessed: "This request has already been processed.",
    },
    ResolveRegistrationRequest: {
      General: "Failed to resolve registration request.",
      NotFound: "Registration request not found.",
      AlreadyResolved: "This request has already been resolved.",
    },
  },
} satisfies ResourceDictionary;
